<template>
    <div>
        <div class="flex items-center justify-between p-20px pt-42px!">
            <div class="w-28px h-28px cursor-pointer" @click="handleBack">
                <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full" />
            </div>
            <div class="font-800 text-16px color-#fff">
                History
            </div>
            <div>

            </div>
        </div>
        <div class="flex items-center p-20px pt-0px tab gap-10px">
            <div class="item" :class="{ 'active': currentTab === 1 }" @click="handleTab(1)">
                Image
            </div>
            <div class="item" :class="{ 'active': currentTab === 2 }" @click="handleTab(2)">
                Video
            </div>
        </div>
        <div class="p-20px pt-0px">
            <template v-if="currentTab === 1">
                <div v-if="historyStore.imageHistory.length > 0" class="flex flex-wrap gap-10px">
                    <div v-for="item in historyStore.imageHistory" :key="item.id" @click="handlePreviewImage(item)"
                        class="w-105px h-158px rounded-10px overflow-hidden">
                        <img :src="item.imageUrl" alt="" class="w-full h-full">
                    </div>
                </div>
                <div v-else class="flex items-center flex-col justify-center h-80vh w-100%">
                    <div class="w-44px h-44px ">
                        <img src="@/assets/images/chat/chatRecord/empty.webp" alt="" class="w-full h-full">
                    </div>
                    <div class="text-12px text-center color-#999 mt-3px">
                        No generated<br />
                        content yet.
                    </div>
                </div>
            </template>
            <template v-else>
                <div v-if="historyStore.videoHistory.length > 0" class="flex flex-wrap gap-10px">
                    <div v-for="item in historyStore.videoHistory" :key="item.id" @click="handlePreviewVideo(item)"
                        class="relative w-105px h-158px rounded-10px overflow-hidden">
                        <!-- 骨架屏 -->
                        <!-- <div v-if="videoLoadingMap.has(item.id)" class="absolute inset-0 bg-gray-800 animate-pulse rounded-10px flex items-center justify-center">
                            <div class="w-24px h-24px rounded-full border-2 border-white border-t-transparent animate-spin"></div>
                        </div> -->
                        <video :src="item.videoUrl" :poster="item.coverImage" alt=""
                            class="w-full h-full object-cover" @loadeddata="videoLoadingMap.delete(item.id)"></video>
                        <div class="absolute top-8px left-8px w-24px h-24px flex items-center justify-center">
                            <img src="@/assets/images/chat/chatRecord/paly.svg" alt="" class="w-full h-full">
                        </div>
                    </div>
                </div>
                <div v-else class="flex items-center flex-col justify-center h-80vh w-100%">
                    <div class="w-44px h-44px ">
                        <img src="@/assets/images/chat/chatRecord/empty.webp" alt="" class="w-full h-full">
                    </div>
                    <div class="text-12px text-center color-#999 mt-3px">
                        No generated<br />
                        content yet.
                    </div>
                </div>
            </template>
        </div>
        <!-- 全屏视频预览 -->
        <ChatFullscreenVideoPreview v-model:show="showVideoPreview" :videos="previewVideos"
            :poster="previewVideoPoster" />

        <!-- 全屏图片预览 -->
        <FullscreenImagePreview v-model:show="showImagePreview" :images="previewImages" :infoItem="infoItem"
            :start-position="previewStartPosition" :isShowSetAsBackdrop="isShowSetAsBackdrop" :is-showback-drop="false" />
    </div>
</template>

<script setup lang="ts">
import { FullscreenImagePreview } from '@/components/feedback'
import ChatFullscreenVideoPreview from './Component/ChatFullscreenVideoPreview.vue'
import { useHistoryStore } from '@/stores/history'
import { onMounted, ref, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const currentTab = ref(1)
const historyStore = useHistoryStore()
const showVideoPreview = ref(false)
const previewVideos = ref<string[]>([])
const previewVideoPoster = ref('')
const showImagePreview = ref(false)
const previewImages = ref<string[]>([])
const infoItem = ref()
const previewStartPosition = ref(0)
const isShowSetAsBackdrop = ref()
const videoLoadingMap = reactive(new Map<string, boolean>())




const handleBack = () => {
    router.back()
}
const handlePreviewVideo = (item: any) => {
    console.log(item,'item');
    
    previewVideos.value = [item.videoUrl]
    previewVideoPoster.value = item.coverImage
    showVideoPreview.value = true
    
    
}
const handlePreviewImage = (item: any) => {
    previewImages.value = [item.imageUrl]
    showImagePreview.value = true
}
const handleTab = (type: number) => {
    currentTab.value = type
}

onMounted(() => {
    historyStore.fetchImageHistory({ page: 1, pageSize: 100, roleId: Number(route.query.id), typeTask: 1 })
    historyStore.fetchVideoHistory({ page: 1, pageSize: 100, roleId: Number(route.query.id), typeTask: 2 }).then(() => {
        // 设置所有视频为加载中状态
        historyStore.videoHistory.forEach((item: any) => {
            videoLoadingMap.set(item.id, true)
        })
    })
})
</script>

<style scoped lang="scss">
.tab {
    .item {
        text-align: center;
        font-size: 16px;
        color: #fff;
        background-color: rgba(255, 255, 255, 0.1);
        padding: 6px 12px;
        border-radius: 20px;
        border: 1px solid transparent;
    }

    .active {
        background: rgba(90, 104, 255, 0.1);
        // border-radius: 14px;
        border: 1px solid #5A68FF;
        color: #5A68FF;
    }

}
</style>